module.exports = __webpack_public_path__ + "t.no2.3ac87cec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/t.no2.jpg
// module id = Qjcm
// module chunks = 0